<template>
  <div class="niste-clan">
	<div>{{ $t("coming_soon.text") }}</div>
	<router-link to="/">{{ $t("coming_soon.go_back") }}</router-link>
  </div>
</template>

<script>
export default {
	

}
</script>

<style>

</style>